var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.offline),callback:function ($$v) {_vm.offline=$$v},expression:"offline"}},[_c('v-card',[_c('v-card-title',[_vm._v(" Offline ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t('Offline'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }